export const getConfigs = (state) => state.configs

export const getSealConfigs = (state) => state.sealConfigs
